import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import Token from "../utils/token";

Vue.use(VueRouter);

// meta: {
//   submenu: "", //layout -> name 一级目录名称
//   menuItem: "", //layout -> children -> name 二级目录名称
// },
const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/index"),
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/search"),
  },
  {
    path: "/cart",
    name: "cart",
    meta: {
      title: '购物车',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/cart"),
  },
  {
    path: "/price",
    name: "price",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/price"),
  },
  {
    path: "/whoisSearch",
    name: "whoisSearch",
    meta: {
      title: 'Whois查询',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/whoisSearch"),
  },
  {
    path: "/whois",
    name: "whois",
    meta: {
      title: 'Whois查询',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/whois"),
  },
  {
    path: "/emailc",
    name: "emailc",
    meta: {
      title: '邮箱认证',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/emailc"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: '登录',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/login"),
  },
  {
    path: "/sige",
    name: "sige",
    meta: {
      title: '免费注册',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/sige"),
  },
  {
    path: "/forgot",
    name: "forgot",
    meta: {
      title: '忘记密码',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/forgot"),
  },
  {
    path: "/my",
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/user/components/layout"),
    children: [
      {
        path: "",
        name: "my",
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/user/index"),
        meta: {
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "管理中心",
              to: "/my"
            },
            {
              isRoute: false,
              name: "控制台",
              to: "/index"
            },
          ]
        }
      },
      {
        path: "domain",
        name: "domain",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: '我的域名',
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myDomain/index"
          ),
      },
      {
        path: "template",
        meta: {
          submenu: "domain",
          menuItem: "domain-myTemplate",
          title: '我的模板',
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "我的模板",
              to: "/my/template",

            },
            {
              isRoute: false,
              name: "模板列表",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/container"
          ),
        children: [
          {
            path: "",
            name: "template",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "我的模板",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的模板",
                  to: "/my/template"
                },
                {
                  isRoute: false,
                  name: "模板列表",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/index"
              ),
          },
          {
            path: "add",
            name: "templateAdd",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "添加模板",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的模板",
                  to: "/my/template"
                },
                {
                  isRoute: false,
                  name: "添加模板",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/add"
              ),
          },
          {
            path: "transfer",
            name: "templateTransfer",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的模板",
                  to: "/my/template"
                },
                {
                  isRoute: false,
                  name: "设置默认模板",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/transfer"
              ),
          },
          {
            path: "default",
            name: "templateDefault",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "设置默认模板",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的模板",
                  to: "/my/template"
                },
                {
                  isRoute: false,
                  name: "模板过户",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/default"
              ),
          },
          {
            path: "transferlist",
            name: "templateTransferlist",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户记录",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的模板",
                  to: "/my/template"
                },
                {
                  isRoute: false,
                  name: "模板过户记录",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/transferlist"
              ),
          },
        ],
      },
      {
        path: "push",
        meta: {
          submenu: "domain",
          menuItem: "domain-push",
          title: "域名PUSH",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/push/container"
          ),
        children: [
          {
            path: "",
            name: "pushIndex",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "域名PUSH",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "域名PUSH",
                  to: "/my/push"
                },
                {
                  isRoute: false,
                  name: "域名PUSH",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/index"
              ),
          },
          {
            path: "receive",
            name: "pushReceive",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "收到的请求",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "域名PUSH",
                  to: "/my/push"
                },
                {
                  isRoute: false,
                  name: "收到的请求",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/receive"
              ),
          },
          {
            path: "sent",
            name: "pushSent",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "发出的请求",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "域名PUSH",
                  to: "/my/push"
                },
                {
                  isRoute: false,
                  name: "发出的请求",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/sent"
              ),
          },
        ],
      },
      {
        path: "transferin",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferin",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/transferin/container"
          ),
        children: [
          {
            path: "",
            name: "transferin",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的转入",
                  to: "/my/transferin"
                },
                {
                  isRoute: false,
                  name: "提交域名转入",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferin/index"
              ),
          },
          {
            path: "record",
            name: "transferinRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入记录",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的转入",
                  to: "/my/transferin"
                },
                {
                  isRoute: false,
                  name: "域名转入记录",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferin/record"
              ),
          },
        ],
      },
      {
        path: "transferout",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferout",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/transferout/container"
          ),
        children: [
          {
            path: "",
            name: "transferout",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的转出",
                  to: "/my/transferout"
                },
                {
                  isRoute: false,
                  name: "域名转出",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferout/index"
              ),
          },
          {
            path: "record",
            name: "transferoutRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出记录",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的转出",
                  to: "/my/transferout"
                },
                {
                  isRoute: false,
                  name: "域名转出记录",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferout/record"
              ),
          },
        ],
      },
      {
        path: "order",
        meta: {
          submenu: "domain",
          menuItem: "domain-order",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/order/container"
          ),
        children: [
          {
            path: "",
            name: "order",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "域名订单",
                  to: "/my/order"
                },
                {
                  isRoute: false,
                  name: "域名订单",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/order/index"
              ),
          },
          {
            path: "detail",
            name: "orderDetail",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单详情",
              toBack: true,
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "域名订单",
                  to: "/my/order"
                },
                {
                  isRoute: false,
                  name: "域名订单详情",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/order/detail"
              ),
          },
        ],
      },
      {
        path: "user",
        meta: {
          submenu: "user",
          menuItem: "user",
        },
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/user/info/container"),
        children: [
          {
            path: "",
            name: "user",
            meta: {
              submenu: "user",
              menuItem: "user-account",
              title: "个人资料",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "账户管理",
                  to: "/my/user/"
                },
                {
                  isRoute: false,
                  name: "个人资料",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/user/info/index"),
          },
          {
            path: "security",
            name: "userSecurity",
            meta: {
              submenu: "user",
              menuItem: "user-security",
              title: "安全中心",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "安全中心",
                  to: "/my/user/security"
                },
                {
                  isRoute: false,
                  name: "安全中心",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/security"
              ),
          },
          {
            path: "certified",
            name: "userCertified",
            meta: {
              submenu: "user",
              menuItem: "user-certified",
              title: "我的认证",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的认证",
                  to: "/my/user/certified"
                },
                {
                  isRoute: false,
                  name: "我的认证",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/certified"
              ),
          },
          {
            path: "mail",
            name: "userMail",
            meta: {
              submenu: "user",
              menuItem: "user-mail",
              title: "站内信",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "站内信",
                  to: "/my/user/mail"
                },
                {
                  isRoute: false,
                  name: "站内信",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/mail"
              ),
          },
          {
            path: "journal",
            name: "userJournal",
            meta: {
              submenu: "user",
              menuItem: "user-journal",
              title: "登录日志",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "登录日志",
                  to: "/my/user/journal"
                },
                {
                  isRoute: false,
                  name: "登录日志",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/journal"
              ),
          },
          {
            path: "myPersonal",
            name: "userMyPersonal",
            meta: {
              submenu: "user",
              menuItem: "user-certified",
              toBack: true,
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的认证",
                  to: "/my/user/certified"
                },
                {
                  isRoute: false,
                  name: "个人认证",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myPersonal"
              ),
          },
          {
            path: "myEnterprise",
            name: "userMyEnterprise",
            meta: {
              submenu: "user",
              menuItem: "user-certified",
              toBack: true,
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的认证",
                  to: "/my/user/certified"
                },
                {
                  isRoute: false,
                  name: "企业认证",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myEnterprise"
              ),
          },
          {
            path: "myEmail",
            name: "userMyEmail",
            meta: {
              submenu: "user",
              menuItem: "user-certified",
              toBack: true,
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "我的认证",
                  to: "/my/user/certified"
                },
                {
                  isRoute: false,
                  name: "邮箱认证",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myEmail"
              ),
          },
        ],
      },
      {
        path: "finance/account",
        name: "financeAccount",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "账户信息",
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "资金管理",
              to: "/my/finance/account"
            },
            {
              isRoute: false,
              name: "账户信息",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/index"
          ),
      },
      {
        path: "finance/account/recharge",
        name: "financeAccountRecharge",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "在线充值",
          toBack: true,
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "账户信息",
              to: "/my/finance/account"
            },
            {
              isRoute: false,
              name: "在线充值",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/recharge"
          ),
      },
      {
        path: "finance/account/cashout",
        name: "financeAccountCashout",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "资金提现",
          toBack: true,
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "账户信息",
              to: "/my/finance/account"
            },
            {
              isRoute: false,
              name: "资金提现",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/cashout"
          ),
      },
      {
        path: "finance/capitaldetails/index",
        name: "financeCapitaldetails",
        meta: {
          submenu: "finance",
          menuItem: "finance-capitaldetails",
          title: "资金明细",
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "资金明细",
              to: "/my/finance/capitaldetails/index"
            },
            {
              isRoute: false,
              name: "资金明细",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/capitaldetails/index"
          ),
      },
      {
        path: "invoice",
        meta: {
          submenu: "finance",
          menuItem: "finance-invoice",
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "发票管理",
              to: "/my/invoice"
            },
            {
              isRoute: false,
              name: "发票管理",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/invoice/container"
          ),
        children: [
          {
            path: "",
            name: "invoice",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
              names: "invoice",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "发票管理",
                  to: "/my/invoice"
                },
                {
                  isRoute: false,
                  name: "发票管理",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/index"
              ),
          },
          {
            path: "apply",
            name: "financeapply",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
              names: "financeapply",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "发票管理",
                  to: "/my/invoice"
                },
                {
                  isRoute: false,
                  name: "发票申请",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/apply"
              ),
          },
          {
            path: "detail",
            name: "invoicedetail",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
              names: "invoicedetail",
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "发票管理",
                  to: "/my/invoice"
                },
                {
                  isRoute: false,
                  name: "发票信息",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/detail"
              ),
          },
          {
            path: "info",
            name: "invoiceinfo",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
              names: "invoice",
              toBack: true,
              breadcrumbData: [
                {
                  isRoute: true,
                  name: "首页",
                  to: "/index"
                },
                {
                  isRoute: true,
                  name: "发票管理",
                  to: "/my/invoice"
                },
                {
                  isRoute: false,
                  name: "发票详情",
                  to: "/index"
                },
              ]
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/info"
              ),
          },
        ],
      },
      {
        path: "domain/analysis",
        name: "domainAnalysis",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: "域名解析",
          toBack: true,
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "我的域名",
              to: "/my/domain"
            },
            {
              isRoute: false,
              name: "域名解析",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myDomain/analysis"
          ),
      },
      {
        path: "domain/dns",
        name: "domainDns",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          toBack: true,
          title: "DNS设置",
          breadcrumbData: [
            {
              isRoute: true,
              name: "首页",
              to: "/index"
            },
            {
              isRoute: true,
              name: "我的域名",
              to: "/my/domain"
            },
            {
              isRoute: false,
              name: "DNS设置",
              to: "/index"
            },
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myDomain/dns"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
// 路由跳转前钩子
router.beforeEach((to, from, next) => {
  if (!(store.state.token.token && store.state.token.token != '')) {
    const rToken = Token.getAll()
    if (rToken && rToken != '') {
      store.commit('MUT_TOKEN_INFO', JSON.parse(rToken));
      store.dispatch('ACT_USER_INFO')
    }
  }
  // 如果已经登录了，不能让它打开登录、注册、忘记密码页面
  const isLogin = store.state.token != "";
  if (
    isLogin &&
    (to.name === "login" || to.name === "sige" || to.name === "forgot")
  ) {
    if (
      from.name === "login" ||
      from.name === "sige" ||
      from.name === "forgot"
    ) {
      next("/index");
    } else {
      next(from);
    }
    return false;
  }
  // 如果是从其他页面去登录页面,记录原本的路由
  if (to.name === "login") {
    const { name, path, query, params } = from;

    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
  }
  // 如果未登录进入个人中心
  if (to.fullPath.search("/my") !== -1 && !isLogin) {
    const { name, path, query, params } = from;
    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
    next("/index");
    return false;
  }
  // if(to.name)
  next();
  if (to.meta.title) {
    document.title = `${to.meta.title} &` + ' 域见未来';
  }
});

export default router;
